<template>
  <div class="landing">
    <b-container class="about-container">
      <b-row class="justify-content-center">
        <b-col>
          <div>
            <h1 class="principal-title">
              {{ $t('aboutUs.main.section.subtitle') }}
            </h1>

            <b-container>
              <h2 class="about-title text-center">
                {{ $t('aboutUs.main.section.howWeDoIt') }}
              </h2>
              <img
                src="https://cdn.vexels.com/img/how-we-do-it.png"
                data-srcset="https://cdn.vexels.com/img/how-we-do-it.png 1x,
                https://cdn.vexels.com/img/how-we-do-it@2x.png 2x"
                :alt="$t('aboutUs.main.section.howWeDoItAlt')"
                class="w-100"
                loading="lazy"
              />
            </b-container>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <div class="content-container">
      <div class="title-container">
        <h2 class="title mb-4 new-content-header">
          {{ $t('aboutUs.main.section.newContent') }}
        </h2>
        <p class="sub-title">
          {{ $t('aboutUs.main.section.proDesigners') }}
        </p>
      </div>
      <div class="amount-resources">
        <h2 class="amount-text">
          {{ $t('aboutUs.main.section.stylesTrends') }}
        </h2>
      </div>
      <img
        src="https://cdn.vexels.com/img/telescope.png"
        data-srcset="https://cdn.vexels.com/img/telescope.png 1x,
        https://cdn.vexels.com/img/telescope@2x.png 2x"
        :alt="$t('aboutUs.main.section.telescopeAlt')"
        class="telescope w-100"
        loading="lazy"
      />
    </div>

    <b-container>
      <WhoBlock
        v-for="(item, index) in whoBlocks"
        :key="index"
        :url-img="item.img"
        :icon="item.icon"
        :icon-color="item.iconColor"
        :title="item.title"
        :sub-title="item.subTitle"
        :content="item.content"
        :left="item.left"
      >
      </WhoBlock>
    </b-container>

    <section class="founders-container text-center">
      <b-container>
        <h2 class="about-title">
          {{ $t('aboutUs.main.section.founders') }}
        </h2>
        <b-row class="w-100 m-0 justify-content-center">
          <b-col
            v-for="(founder, idx) in founders"
            :key="idx"
            cols="12"
            sm="4"
            class="founder-info"
          >
            <img
              :src="founder.img"
              class="img-founder"
              :data-srcset="founder.srcset"
              :alt="`${$t('about.main.section.foundersAlt')} ${founder.name}`"
              loading="lazy"
            />
            <p class="title-text">{{ founder.name }}</p>
            <p class="subtitle-text">{{ founder.role }}</p>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <section class="team-container text-center">
      <b-container>
        <h2 class="about-title text-center">
          {{ $t('aboutUs.main.section.team') }}
        </h2>
        <img
          src="https://cdn.vexels.com/img/team.png"
          data-srcset="https://cdn.vexels.com/img/team.png 1x,
          https://cdn.vexels.com/img/team@2x.png 2x"
          :alt="$t('aboutUs.main.section.teamAlt')"
          class="w-100"
          loading="lazy"
        />
      </b-container>
    </section>

    <section class="creativity-container text-center">
      <b-container>
        <h2 class="about-title text-center">
          {{ $t('aboutUs.main.section.creativity') }}
        </h2>
        <b-row class="w-100 m-0 justify-content-center">
          <b-col v-for="(elem, idx) in creativity" :key="idx" cols="12" sm="6" md="3">
            <img
              :src="elem.img"
              :alt="`${$t('aboutUs.main.section.creativityIconsAlt')} ${elem.title}`"
            />
            <p class="title-text">{{ elem.title }}</p>
            <p class="subtitle-text">{{ elem.desc }}</p>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <TrustedBy class="trusted-featured-container" />
    <FeaturedIn class="trusted-featured-container" />
    <LetsChat />
  </div>
</template>

<script>
import WhoBlock from '@/components/Enterprise/WhoBlock';
import TrustedBy from '@/components/Common/TrustedBy';
import FeaturedIn from '@/components/Common/FeaturedIn';
import LetsChat from '@/components/Common/LetsChat';

export default {
  name: 'AboutUs',
  nuxtI18n: {
    paths: {
      en: '/about-us',
      de: '/about-us',
      es: '/sobre-nosotros',
      pt: '/sobre-nos'
    }
  },
  components: {
    WhoBlock,
    TrustedBy,
    LetsChat,
    FeaturedIn
  },
  data() {
    return {
      playerOptions: {
        language: 'en',
        playbackRates: [1.0],
        sources: [
          {
            type: 'video/mp4',
            src: 'https://images.vexels.com/files/web/assets/meet-vexels.mp4'
          }
        ],
        poster: 'https://cdn.vexels.com/img/preview-video-vexels.jpg'
      },
      founders: [
        {
          name: 'Mati',
          role: 'CEO',
          img: 'https://cdn.vexels.com/img/mati.png',
          srcset:
            'https://cdn.vexels.com/img/mati.png 1x, https://cdn.vexels.com/img/mati@2x.png 2x'
        },
        {
          name: 'Seba',
          role: 'Art director',
          img: 'https://cdn.vexels.com/img/seba.png',
          srcset:
            'https://cdn.vexels.com/img/seba.png 1x, https://cdn.vexels.com/img/seba@2x.png 2x'
        },
        {
          name: 'Leo',
          role: 'CMO',
          img: 'https://cdn.vexels.com/img/leo.png',
          srcset: 'https://cdn.vexels.com/img/leo.png 1x, https://cdn.vexels.com/img/leo@2x.png 2x'
        }
      ],
      creativity: [
        {
          title: '150+',
          desc: 'barbacues',
          img: 'https://cdn.vexels.com/img/icons/barbacues.svg'
        },
        {
          title: '400+',
          desc: 'ping pong games',
          img: 'https://cdn.vexels.com/img/icons/ping-pong.svg'
        },
        {
          title: '3K',
          desc: 'lts of coffee',
          img: 'https://cdn.vexels.com/img/icons/coffee.svg'
        },
        {
          title: '150+',
          desc: 'afternoons in the pool',
          img: 'https://cdn.vexels.com/img/icons/pool.svg'
        }
      ],
      whoBlocks: [
        {
          left: true,
          icon: 'hottest',
          iconColor: '#3f80f1',
          title: 'aboutUs.main.section.blockTitle1',
          subTitle: 'aboutUs.main.section.blockSubtitle1',
          content: 'aboutUs.main.section.blockContent1',
          img: 'https://cdn.vexels.com/img/in-house.png'
        },
        {
          left: false,
          icon: 'request',
          iconColor: '#3f80f1',
          title: 'aboutUs.main.section.blockTitle2',
          subTitle: 'aboutUs.main.section.blockSubtitle2',
          content: 'aboutUs.main.section.blockContent2',
          img: 'https://cdn.vexels.com/img/marketing-grid.png'
        },
        {
          left: true,
          icon: 'online-editor',
          iconColor: '#3f80f1',
          title: 'aboutUs.main.section.blockTitle3',
          subTitle: 'aboutUs.main.section.blockSubtitle3',
          content: 'aboutUs.main.section.blockContent3',
          img: 'https://cdn.vexels.com/img/dev-grid.png'
        }
      ]
    };
  },
  head() {
    const i18nSeo = this.$seoPlugin({ slash: true });
    return {
      link: [...i18nSeo.link]
    };
  }
};
</script>

<style lang="scss" src="./styles.scss" scoped></style>
<style scoped>
.new-content-header {
  line-height: 100%;
}
</style>
